/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  DashBoardState,
  GetExpertEarningsReposnse,
} from './interface';

export const initialState: DashBoardState = {
  loading: false,
  topSessions: [],
  coachingHours: [],
  sessionsOverview: {
    bookedSessions: 0,
    completedSessions: 0,
    pendingSessions: 0,
  },
  loadingTopSessions: false,
  loadingCoachingHours: false,
  loadingSessionsOverview: false,
  LoadingExpertEngagement: false,
  loadingExpertEarning: false,
  expertEngagement: {
    likes: 0,
    comments: 0,
  },
  expertEarning: {
    pendingProfileEarnings: [],
    pendingSessionEarnings: [],
    profileEarnings: 0,
    sessionEarnings: 0,
  },
};

export const dashboardSlice = createSlice({
  name: 'feature/dashboard',
  initialState,
  reducers: {
    getTopSessions(state: DashBoardState) {
      state.loadingTopSessions = true;
    },
    getTopSessionsSucceeded(state: DashBoardState, action: PayloadAction<any>) {
      state.loadingTopSessions = false;
      state.topSessions = action.payload;
    },
    getTopSessionsFailed(state: DashBoardState) {
      state.loadingTopSessions = false;
    },
    getCoachingHours(state: DashBoardState) {
      state.loadingCoachingHours = true;
    },
    getCoachingHoursSucceeded(state: DashBoardState, action: PayloadAction<any>) {
      state.loadingCoachingHours = false;
      state.coachingHours = action.payload;
    },
    getCoachingHoursFailed(state: DashBoardState) {
      state.loadingCoachingHours = false;
    },
    getSessionsOverview(state: DashBoardState) {
      state.loadingSessionsOverview = true;
    },
    getSessionsOverviewSucceeded(state: DashBoardState, action: PayloadAction<any>) {
      state.loadingSessionsOverview = false;
      state.sessionsOverview = action.payload;
    },
    getSessionsOverviewFailed(state: DashBoardState) {
      state.loadingSessionsOverview = false;
    },
    getExpertEngagement(state: DashBoardState) {
      state.LoadingExpertEngagement = true;
    },
    getExpertEngagementSucceeded(state: DashBoardState, action: PayloadAction<any>) {
      state.LoadingExpertEngagement = false;
      state.expertEngagement = action.payload;
    },
    getExpertEngagementFailed(state: DashBoardState) {
      state.LoadingExpertEngagement = false;
    },
    getExpertEarning(state: DashBoardState) {
      state.loadingExpertEarning = true;
      state.expertEarning = initialState.expertEarning;
    },
    getExpertEarningSucceeded(
      state: DashBoardState,
      action: PayloadAction<GetExpertEarningsReposnse>,
    ) {
      const {
        pendingSessionEarnings,
        pendingProfileEarnings,
        profileEarnings,
        sessionEarnings,
      } = action.payload;
      state.expertEarning.pendingSessionEarnings = pendingSessionEarnings;
      state.expertEarning.pendingProfileEarnings = pendingProfileEarnings;
      state.expertEarning.profileEarnings = profileEarnings;
      state.expertEarning.sessionEarnings = sessionEarnings;
      state.loadingExpertEarning = false;
    },
    getExpertEarningFailed(state: DashBoardState) {
      state.loadingExpertEarning = false;
    },
  },
});

export const { actions: dashboardActions } = dashboardSlice;
